import { DateUtil, isNullOrUndefined } from '@uzurv/core';
import { Deserialize, inheritSerialization, Serialize } from 'cerialize';
import { ApprovalRequestSubmission } from './approval-request-submission';
import { ClientFeeSchedule } from './client-fee-schedule';

@inheritSerialization(ApprovalRequestSubmission)
export class ClientFeeScheduleApprovalRequest extends ApprovalRequestSubmission {
  get clientFeeSchedule(): ClientFeeSchedule {
    return Deserialize(this.approvalObject, ClientFeeSchedule);
  }

  setActive() {
    const clientFeeSchedule: ClientFeeSchedule = this.clientFeeSchedule;
    clientFeeSchedule.active = true;
    this.approvalObject = Serialize(clientFeeSchedule, ClientFeeSchedule);
  }

  static OnSerialized(instance: ClientFeeScheduleApprovalRequest, json: any): void {
    if (!isNullOrUndefined(instance?.clientFeeSchedule?.effectiveDate)) {
      json.approvalObject.effectiveDate = DateUtil.serializeLocalDate(instance.clientFeeSchedule.effectiveDate);
    }
  }
}
